import React, { useEffect, useState } from 'react'
import { List, Space, Tag, theme, Tooltip, Typography } from 'antd';

const { useToken } = theme;

const OverflowWithTooltip = ({ values, columnWidth }) => {
  const [visibleItems, setVisibleItems] = useState([])
  const [hiddenItems, setHiddenItems] = useState([])
  const { token } = useToken();

  const measureTextWidth = (text,) => {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    return context.measureText(text).width;
  };

  useEffect(() => {
    let tempVisibleItems = [];
    let tempHiddenItems = [];
    let totalWidth = 0;
    const padding = token.paddingXS; // spacing for tags

    values.forEach((val) => {
      const itemWidth = measureTextWidth(val) + token.paddingSM; // text + tag padding
      if ((totalWidth + itemWidth + padding < columnWidth) && tempVisibleItems.length < 2) {
        tempVisibleItems.push(val);
        totalWidth += itemWidth;
      } else {
        tempHiddenItems.push(val);
      }
    });
    setVisibleItems(tempVisibleItems)
    setHiddenItems(tempHiddenItems)
  }, [values, columnWidth])


  if (!values || values?.length === 0 || values?.size === 0) return null;

  return (
    <Space wrap size={[token.paddingXXS, token.paddingXXS]} style={{ maxWidth: columnWidth }}>
      {visibleItems.map((val, idx) => (
        <Tag className="overflow-tag" style={{ cursor: "default" }} key={idx}>
          {val}
        </Tag>
      ))}

      {hiddenItems.length > 0 && (
        <Tooltip
          title={
            <List
              dataSource={hiddenItems}
              renderItem={(item, index) => (
                <List.Item style={{ border: "none", padding: "2px 0" }}>
                  <Typography.Text style={{ color: token.colorWhite }}>
                    {index + 1}. {item}
                  </Typography.Text>
                </List.Item>
              )}
            />
          }
        >
          <Tag
            className="overflow-tag pointer"
            color="purple"
          >
            {`+${hiddenItems.length} `}
          </Tag>
        </Tooltip>
      )}
    </Space>
  );
};

export default OverflowWithTooltip;
